var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDownRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M216.09 239.976 104.16 240c-6.594 0-11.938-5.343-11.937-11.937l.004-18.335c.001-6.594 5.348-11.94 11.943-11.942l65.444-.014L42.916 71.073c-3.888-3.888-3.888-10.19 0-14.079l14.078-14.078c3.888-3.888 10.191-3.888 14.08 0l126.698 126.698.014-65.444c.001-6.595 5.348-11.942 11.943-11.943l18.334-.004c6.594-.001 11.937 5.343 11.937 11.938l-.024 111.929c-.004 13.188-10.698 23.882-23.886 23.886"
})));
export default SvgArrowDownRight;